export default "__VITE_ASSET__N8pgCD0S__"